import type { TenderDocument } from '../../../../../shared/entities/TenderDocument';
import { naturalCompare } from '../../../../../shared/utils/strings';

const DEPRIORITIZED_EXTENSIONS = ['.pdf', '.docx'] as const;
const PRIORITIZED_EXTENSIONS = ['.xlsx', '.xls', '.csv', '.ods'] as const;

export const sortDocumentsPerFileExtension = (
  documents: TenderDocument[],
): TenderDocument[] => {
  const sortedDocuments = [...documents];

  return sortedDocuments.sort((a, b) => {
    const isAPrioritized = hasPrioritizedExtension(a.originalName);
    const isBPrioritized = hasPrioritizedExtension(b.originalName);
    const isADeprioritized = hasDeprioritizedExtension(a.originalName);
    const isBDeprioritized = hasDeprioritizedExtension(b.originalName);

    // If both files are prioritized or both are not, compare their priority status
    if (isAPrioritized === isBPrioritized) {
      // If both files have same deprioritized status, sort by name
      if (isADeprioritized === isBDeprioritized) {
        return naturalCompare(a.prettyName, b.prettyName);
      }
      // Sort deprioritized files last
      return isADeprioritized ? 1 : -1;
    }
    // Sort prioritized files first
    return isAPrioritized ? -1 : 1;
  });
};

const hasDeprioritizedExtension = (fileName: string): boolean => {
  return DEPRIORITIZED_EXTENSIONS.some(ext =>
    fileName.toLowerCase().endsWith(ext),
  );
};

const hasPrioritizedExtension = (fileName: string): boolean => {
  return PRIORITIZED_EXTENSIONS.some(ext =>
    fileName.toLowerCase().endsWith(ext),
  );
};
